import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Message } from 'primeng/primeng';
import { RadicationSSService } from '../../../service/radicationSS/radicationSS.service';
import { RadicationSS } from '../../../class/radicationSS';

@Component({
  selector: 'app-radication-ss',
  templateUrl: './radication-ss.component.html',
  styleUrls: ['./radication-ss.component.scss']
})
export class RadicationSSComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() infoRadicationSS: RadicationSS;
    public radicationSS: RadicationSS;
    public msgs: Message[] = [];

    constructor(
        public radicationSSService: RadicationSSService) {
    }

    ngOnInit() {
    }

    public cancelRadicationSS () {
        this.close.emit(true);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/radication-ss/radication-ss/radication-ss.component.ts